// Fecha de entrega con días naturales (los mismos que dice la ficha). Solo lectura.

const DAYS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
const MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sept", "oct", "nov", "dic"];

/** Una fecha sin hora (UTC a mediodía: no se mueve con el horario de verano). */
function day(year: number, month: number, date: number): Date {
  return new Date(Date.UTC(year, month - 1, date, 12));
}

function addDays(value: Date, count: number): Date {
  return new Date(value.getTime() + count * 86400000);
}

/** «vie 30 oct». */
export function shortDate(value: Date): string {
  return DAYS[value.getUTCDay()] + " " + String(value.getUTCDate()) + " " + MONTHS[value.getUTCMonth()];
}

export interface Delivery {
  from: Date;
  to: Date;
}

/**
 * La ventana de entrega para un pedido hecho en «now» (hora de España: year, month, date, hour, minute):
 * de hoy + mínimo a hoy + máximo días naturales.
 * cutoff = «14:00» si el vendedor lo dio: después, el día 0 es mañana.
 */
export function deliveryWindow(now: { year: number; month: number; date: number; hour: number; minute: number }, minDays: number, maxDays: number, cutoff?: string): Delivery {
  const today = day(now.year, now.month, now.date);
  let late = false;
  if (cutoff) {
    const [hour, minute] = cutoff.split(":").map(Number);
    late = now.hour * 60 + now.minute >= hour * 60 + minute;
  }
  const zero = late ? addDays(today, 1) : today;
  return { from: addDays(zero, minDays), to: addDays(zero, maxDays) };
}

/** Ahora en España, sin depender de la zona del navegador. */
export function spainNow(clock: Date = new Date()): { year: number; month: number; date: number; hour: number; minute: number } {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Madrid", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", hourCycle: "h23" }).formatToParts(clock);
  const part = (type: string) => Number(parts.find((item) => item.type === type)?.value ?? "0");
  return { year: part("year"), month: part("month"), date: part("day"), hour: part("hour"), minute: part("minute") };
}

/** La frase de E10: «Pide hoy y llega entre el vie 30 oct y el dom 1 nov». */
export function deliverySentence(window: Delivery): { lead: string; from: string; to?: string } {
  const from = shortDate(window.from);
  const to = shortDate(window.to);
  return from === to ? { lead: "Pide hoy y llega el", from } : { lead: "Pide hoy y llega entre el", from, to };
}
